@if (!refreshing) {
  <div id="consultNoteDetailPage">
    <app-consult-note-title [patientAttachment]="patientAttachment" />
    <app-consult-note-header [patientAttachment]="patientAttachment" />
    @if (!loadingHistoryItems) {
      <div class="patient-attachment-history">
        <table class="table table-striped mt-3">
          <tbody>
            @for (patientAttachmentHistoryItem of patientAttachmentHistoryItems; track patientAttachmentHistoryItem) {
              <tr>
                <td class="highlighted">
                  <div>{{ patientAttachmentHistoryItem.createdAt | date: 'MM/dd/yyyy' }}</div>
                  <div>{{ patientAttachmentHistoryItem.createdAt | date: 'hh:mm a' }}</div>
                </td>
                <td>
                  <div>
                    @switch (patientAttachmentHistoryItem.action) {
                      @case (patientAttachmentHistoryItemActions.created) {
                        <app-consult-note-history-item-type-created
                          [patientAttachmentHistoryItem]="patientAttachmentHistoryItem" />
                      }
                      @case (patientAttachmentHistoryItemActions.transitioned) {
                        <app-consult-note-history-item-type-transitioned
                          [patientAttachmentHistoryItem]="patientAttachmentHistoryItem" />
                      }
                      @case (patientAttachmentHistoryItemActions.submitted) {
                        <app-consult-note-history-item-type-submitted
                          [patientAttachmentHistoryItem]="patientAttachmentHistoryItem" />
                      }
                      @case (patientAttachmentHistoryItemActions.assignmentNew) {
                        <app-consult-note-history-item-type-assignment-new
                          [patientAttachmentHistoryItem]="patientAttachmentHistoryItem" />
                      }
                      @case (patientAttachmentHistoryItemActions.assignmentUpdated) {
                        <app-consult-note-history-item-type-assignment-updated
                          [patientAttachmentHistoryItem]="patientAttachmentHistoryItem" />
                      }
                      @case (patientAttachmentHistoryItemActions.assignmentRemoved) {
                        <app-consult-note-history-item-type-assignment-removed
                          [patientAttachmentHistoryItem]="patientAttachmentHistoryItem" />
                      }
                      @default {
                        <app-consult-note-history-item-type-base
                          [patientAttachmentHistoryItem]="patientAttachmentHistoryItem" />
                      }
                    }
                  </div>
                </td>
                <td class="highlighted">{{ patientAttachmentHistoryItem | historyItemUserName }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <mat-spinner />
    }
  </div>
} @else {
  <mat-spinner />
}
